import { createAsyncThunk } from "@reduxjs/toolkit";
import { UrlConstant } from "../../commom/UrlConstant";
import { SubmitCashoutResult } from "../../types/cashout.types";
import Axios from "../../config/axios";

export const submitCashoutRequest = createAsyncThunk(
    'cashout/submitCashoutRequest',
    async (
        payload: { selectedAssets: any[]; totalAmount: number },
        { rejectWithValue }
    ) => {
        try {
            const response = await Axios.post(UrlConstant.Cashout.SubmitCashoutRequest, {
                selectedAssets: payload.selectedAssets.map(asset => ({
                    ...asset,
                    selectedCashOutQuantity: asset.selectedCashOutQuantity,
                })),
                totalAmount: payload.totalAmount,
            });

            if (response.data.success) {
                return response.data;   // 200 full success → fulfilled
            }

            // 207 partial OR 400 full failure → rejected with structured payload
            const structured: SubmitCashoutResult = response.data.data ?? {
                success: [],
                failed: (response.data.errors ?? [response.data.message ?? 'Unknown error']).map(
                    (msg: string) => ({ assetId: undefined, asset: 'Unknown', error: msg, type: 'UNKNOWN' })
                ),
                totalProcessed: 0,
                totalAmount: 0,
            };

            return rejectWithValue({
                ...structured,
                hasAsyncOrders: response.data.hasAsyncOrders ?? false,
            });

        } catch (error: any) {
            const rawData = error.response?.data;
            const structured: SubmitCashoutResult = rawData?.data ?? {
                success: [],
                failed: [{
                    assetId: undefined,
                    asset: 'Request',
                    error: rawData?.message || error.message || 'Failed to submit cashout request',
                    type: 'UNKNOWN',
                }],
                totalProcessed: 0,
                totalAmount: 0,
            };
            return rejectWithValue({
                ...structured,
                hasAsyncOrders: rawData?.hasAsyncOrders ?? false,
            });
        }
    }
);

export const fetchAvailableAssets = createAsyncThunk(
    'cashout/fetchAvailableAssets',
    async (_, { rejectWithValue }) => {
        try {
            const response = await Axios.get(UrlConstant.Cashout.GetCashoutAssets);

            if (!response.data.success) {
                return rejectWithValue(response.data.message || 'Failed to fetch assets');
            }

            return {
                data: response.data.data,
                metadata: response.data.metadata,
            };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch available assets'
            );
        }
    }
);